<template>
    <my-dialog title="门店库存调拨" dialogType="form" :visible.sync="showDialog" :close-on-click-modal="false"
        @close="closeDialog" width="80%">
        <div class="item_info border_Green">
            <el-descriptions class="margin-top" title="调拨门店" :column="4" border>
                <el-descriptions-item>
                    <template slot="label">
                        调出门店
                    </template>
                    <el-select v-model="editForm.transferOutStoreKeyId" placeholder="请选择门店" clearable filterable
                        size="small">
                        <el-option v-for="item in transferOutStoreList" :label="item.value" :value="item.keyId"
                            :key="item.keyId"></el-option>
                    </el-select>
                </el-descriptions-item>
                <el-descriptions-item>
                    <template slot="label">
                        调入门店
                    </template>
                    <el-select v-model="editForm.transferInStoreKeyId" placeholder="请选择门店" clearable filterable
                        size="small">
                        <el-option v-for="item in trensferInStoreList" :label="item.value" :value="item.keyId"
                            :key="item.keyId"></el-option>
                    </el-select>
                </el-descriptions-item>
            </el-descriptions>
        </div>
        <div class="item_info border_Green">
            <div class="item_title">
                <div class="title">商品信息</div>
                <div class="btnDiv">

                </div>
            </div>
            <el-table :data="transferProductDtlData" border stripe style="width: 100%;border-radius: 10px;"
                :header-cell-style="{ textAlign: 'center', backgroundColor: '#b3e0ff' }"
                :cell-style="{ textAlign: 'center' }">
                <el-table-column prop="rowNumber" label="序号" width="60"></el-table-column>
                <el-table-column prop="typeName" label="类型名称" width="120"></el-table-column>
                <el-table-column prop="productName" label="商品名称"></el-table-column>
                <el-table-column prop="specification" label="规格"></el-table-column>
                <el-table-column prop="price" label="单价" width="90"></el-table-column>
                <el-table-column prop="quantity" label="数量" width="90"></el-table-column>
                <el-table-column prop="money" label="金额" width="90"></el-table-column>
                <el-table-column prop="util" label="单位" width="60"></el-table-column>
            </el-table>
        </div>
        <div slot="footer" class="dialog-footer">
            <el-button size="small" @click="closeDialog">关闭</el-button>
        </div>
    </my-dialog>
</template>

<script>

import {
    GetOrgInfoListByConfig
} from "@/api/organizationalApi.js";
export default {
    data() {
        return {
            showDialog: false,
            editForm: {
                transferInStoreKeyId: "",
                transferOutStoreKeyId: "",
                transferProductDtlList: [],
            },
            transferProductDtlData: [],
            trensferInStoreList: [],
            transferOutStoreList: [],
            transferProductKeyIdList: [],
        };
    },
    // 注册组件
    components: {

    },
    created() { },
    computed: {},
    methods: {
        showTransferDialog(selectedRows) {
            this.showDialog = true;
            this.transferProductKeyIdList = selectedRows;
            this.GetOrgInfoListByConfig();
        },
        closeDialog() {
            this.showDialog = false;
            this.editForm = {
                transferInStoreKeyId: "",
                transferOutStoreKeyId: "",
                transferProductDtlList: [],
            };
        },
        // 获取所属门店
        GetOrgInfoListByConfig() {
            const paramer = {
                key: 1,
            };
            GetOrgInfoListByConfig(paramer)
                .then((res) => {
                    this.transferOutStoreList = [];
                    if (res.code == 1) {
                        res.data.forEach((item) => {
                            this.transferOutStoreList.push({
                                keyId: item.keyId,
                                value: item.name + '【' + item.remark2 + '】',
                            });
                        });
                        this.editForm.transferOutStoreKeyId = this.transferOutStoreList[0].keyId;
                    } else {
                        this.$message.error(res.msg);
                    }
                })
                .catch((err) => {
                    this.loading = false;
                    this.$message.error("获取门店信息失败!");
                });
        },
    },
};
</script>

<style scoped>
.selectContent {
    margin-top: 20rpx;
    display: flex;
    justify-content: center;
    align-items: center;
}

.item_info {
    border-left: 5px solid #55aaff;
    padding: 5px 10px;
    border-radius: 5px;
    margin-bottom: 15px;
    border-bottom: 2px solid #e9e7e7;
}

.border_Green {
    border-left: 5px solid #00cc66;
}
</style>